import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTablesDisplayGridRowDataFragmentGql } from './VirtualConnectionTablesDisplayGridRowDataFragmentGql';

export const WorkbookUpstreamVirtualConnectionTablesQueryGql: DocumentNode = gql`
query WorkbookUpstreamVirtualConnectionTablesQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  workbooks(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${VirtualConnectionTablesDisplayGridRowDataFragmentGql}
`;
